import api from "../api/axiosInstance";

// fetch matches for current user
export const fetchAllMatchesFilters = async () => {
  try {
    const res = await api.get("/masters/all");
    return res.data;
  } catch (error) {
    console.error("Error fetching matches:", error);
    throw error;
  }
};

//get all profiles
export const fetchAllProfiles = async () => {
  try {
    const res = await api.get("/profiles/all");
    return res.data;
  } catch (error) {
    console.error("Error fetching profiles:", error);
    throw error;
  }
};

//Send intrest to profile
export const sendInterest = async (profileId) => {
  try {
    const res = await api.post(`/interests/send/${profileId}`);
    return res.data;
  } catch (error) {
    console.error("Error sending interest:", error);
    throw error;
  }
};

//shortlist profile
export const addShortlistProfile = async (profileId) => {
  try {
    const res = await api.post(`/shortlist/${profileId}`);
     return res.data;
  } catch (error) {
    console.error("Error shortlisting profile:", error);
    throw error;
  }
};

//block profile
export const blockProfile = async (profileId) => {
  try {
    const res = await api.post(`/block/${profileId}`);
     return res.data;
  } catch (error) {
    console.error("Error blocking profile:", error);
    throw error;
  }
};